import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import { toast } from "react-toastify";
import { Logo, welogo } from "../../Assets/common";
import {
  ADMIN,
  CLIENT,
  CLIENT_VENDOR,
  PROJECT_COORDINATOR,
  SUBMISSION_SPECIALIST
} from "../../constants/roles";
import { AuthService } from "../../services/AuthService";
import DisclaimerModal from "../../Modal/DisclaimerModal";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [isDisclaimerOpen, setDisclaimerOpen] = useState(false);

  /* 🔹 ADDED STATE */
  const [showRolePopup, setShowRolePopup] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!role) {
      toast.warn("Please select a role");
      return;
    }

    setIsLoading(true);

    if (role !== CLIENT) {
      try {
        console.log("user data",email, password, role);    
        const response = await AuthService.login({ email, password, role });
        console.log("response data of login",response);
        
        if (response) {
          toast.success(
            "Please verify the OTP sent on your registered email address to login."
          );
          navigate("/verify-otp", { state: { role, email, showToast: true } });
        }
      } catch (error) {
        console.log("error of login",error);
        
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        const response = await AuthService.clientLogin({
          email,
          password,
          role,
        });
        if (response) {
          navigate("/verify-otp", { state: { role, email, showToast: true } });
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const roleLabels = {
  [ADMIN]: "Admin",
  [PROJECT_COORDINATOR]: "Project Coordinator",
  [CLIENT_VENDOR]: "Technical Consultant",
  [CLIENT]: "Client",
  [SUBMISSION_SPECIALIST]: "Submission Specialist",

};


  return (
    <div className="h-screen bg-gray-50 px-4 relative">
      {/* Header */}
      <div className="flex items-center gap-10 py-3 pl-3 md:pl-8">
        <img src={Logo} alt="logo" className="w-36 h-12 xl:w-60 xl:h-20" />
      </div>

      {/* Main Content */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
        {/* Left Text Section */}
        <div className="w-full md:w-[50%] mt-6">
          <h1 className="text-3xl md:text-5xl font-semibold text-purple-800 mb-2">
            Welcome to <span className="text-purple-600">MRR PMS</span>
          </h1>

          <p className="text-lg md:text-2xl text-purple-700 font-medium mb-1">
            Your personal scientific assistant
          </p>

          <p className="text-sm md:text-lg italic text-gray-600">
            by{" "}
            <a
              href="https://myresearchroom.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold bg-gradient-to-r from-purple-500 to-indigo-500 text-transparent bg-clip-text hover:from-purple-600 hover:to-indigo-600 transition"
            >
              MyResearchRoom
            </a>
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-md shadow-2xl p-6 md:p-8 w-full max-w-md border-t-4 border-purple-800">
          <h2 className="text-lg md:text-xl xl:text-2xl font-semibold text-center text-gray-800 mb-4">
            LOG IN
          </h2>

          <form onSubmit={handleLogin} className="space-y-4">

            {/* 🔹 DESKTOP SELECT (UNCHANGED) */}
            <select
              value={role}
              required
              onChange={(e) => setRole(e.target.value)}
              className="hidden md:block w-full text-sm xl:text-base px-2 md:px-4 py-2 xl:py-3 border rounded-md text-gray-600 outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option value="">Select Role</option>
              <option value={ADMIN}>Admin</option>
              <option value={PROJECT_COORDINATOR}>
                Project Coordinator
              </option>
              <option value={CLIENT_VENDOR}>Technical Consultant</option> 
              <option value={CLIENT}>Client</option>
              <option value={SUBMISSION_SPECIALIST}>Submission Specialist</option>

            </select>

            {/* 🔹 MOBILE TRIGGER */}
            <button
              type="button"
              onClick={() => setShowRolePopup(true)}
              className="md:hidden w-full text-left px-3 py-3 border rounded-md text-gray-600 text-sm"
            >
              {role ? roleLabels[role] : "Select Role"}

            </button>

            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="text-xs md:text-sm xl:text-base w-full px-2 md:px-4 py-2 xl:py-3 border rounded-md outline-none focus:ring-2 focus:ring-blue-400"
            />

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
                className="w-full  text-xs md:text-sm xl:text-base px-2 md:px-4 py-2 xl:py-3 border rounded-md outline-none focus:ring-2 focus:ring-blue-400"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-4 right-2 flex items-center cursor-pointer text-gray-600 "
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </span>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-3 rounded-md text-white font-semibold transition ${
                isLoading
                  ? "bg-gradient-to-r from-purple-500 to-indigo-500 cursor-not-allowed"
                  : "bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600"
              }`}
            >
              {isLoading ? "Sending OTP..." : "LOG IN"}
            </button>
          </form>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 text-sm md:text-[16px] pt-2">
            <div className="flex items-center gap-2">
              <MdMailOutline size={20} />
              <p>info@myresearchroom.com</p>
            </div>
            <div className="flex items-center gap-2">
              <IoCallOutline size={20} />
              <p>+91 8767897950</p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 MOBILE ROLE POPUP */}
      {showRolePopup && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center md:hidden">
          <div className="bg-white w-[90%] rounded-lg p-5 space-y-3">
            <h3 className="text-lg font-semibold text-center">
              Select Role
            </h3>

            {[ADMIN, PROJECT_COORDINATOR, CLIENT_VENDOR, CLIENT].map((r) => (
  <button
    key={r}
    onClick={() => {
      setRole(r);
      setShowRolePopup(false);
    }}
    className="w-full py-2 border rounded-md hover:bg-purple-50"
  >
    {roleLabels[r]}
  </button>
))}

    
            <button
              onClick={() => setShowRolePopup(false)}
              className="w-full text-sm text-gray-500 mt-2"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

{/* Footer */} <div className="fixed md:absolute bottom-0 left-0 right-0 w-full bg-gray-50 px-4 py-3"> {/* Top Row */} <div className="flex justify-between items-start"> {/* Left Logo */} <img src={welogo} alt="logo" className="h-16 w-auto object-contain" /> {/* Right Links */} <div className="flex flex-col items-end mt-6"> <div className="flex gap-3 text-blue-600 underline text-sm"> <a href="https://www.linkedin.com/company/wesolutize-technologies/posts/" target="_blank" rel="noopener noreferrer" > LinkedIn </a> <a href="https://www.youtube.com/@WeSolutizeTechnologies" target="_blank" rel="noopener noreferrer" > YouTube </a> </div> </div> </div> {/* Bottom Row */} <div className="flex flex-col md:flex-row justify-between items-center gap-2 mt-2 text-xs md:text-sm"> <p className="text-gray-600 text-center md:text-left"> Designed and Developed by{" "} <a href="https://www.wesolutize.com/" target="_blank" rel="noopener noreferrer" className="hover:underline decoration-purple-700 decoration-2 text-transparent bg-clip-text bg-gradient-to-r from-purple-700 to-blue-800" > NeoWesolutize Technologies </a> </p> <p className="italic underline cursor-pointer text-center md:text-right" onClick={() => setDisclaimerOpen(true)} > Access is limited to verified users in accordance with{" "} <span className="hover:text-blue-700">Company Policy.</span> </p> </div> </div>
    </div>
  );
}
